import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerBankAccount } from '@usf/payment-types';

@Component({
  selector: 'app-bank-account-list',
  templateUrl: './bank-account-list.component.html',
  styleUrls: ['./bank-account-list.component.scss'],
})
export class BankAccountListComponent {
  @Input() bankAccounts: CustomerBankAccount[] = [];
  @Input() isDesktop: boolean;
  @Input() isSettingUpAutopay: boolean;
  @Input() bankIdSelected: string;
  @Output()
  selectBankAccountEmitter: EventEmitter<CustomerBankAccount> =
    new EventEmitter();

  selectBankAccount(bankAccount: CustomerBankAccount) {
    this.selectBankAccountEmitter.emit(bankAccount);
  }

  trackItem(_: any, item: CustomerBankAccount) {
    return item.bankID;
  }
}
